<template>
  <el-form
    class="machineAuditModel"
    ref="formRef"
    :model="formData"
    :rules="rules"
    size="small"
    label-width="130px"
  >
    <el-form-item label="当前状态">
      <el-tag :type="detailData.releaseStatus == 200 ? 'warning' : 'danger'">
        {{ detailData.releaseStatus == 200 ? "机器待审核" : "机器审核不通过" }}
      </el-tag>
    </el-form-item>
    <el-form-item label="审核结果" prop="reviewResult">
      <el-radio-group v-model="formData.reviewResult">
        <el-radio :label="1">通过</el-radio>
        <el-radio :label="2">不通过</el-radio>
      </el-radio-group>
      <!-- <div class="tip-text" v-if="formData.reviewResult === 1">
        提示：强制通过后，应用将进入人工审核阶段
      </div> -->
    </el-form-item>
    <el-form-item
      label="原因"
      prop="reason"
      :rules="[
        { required: formData.reviewResult === 2, message: '请输入原因' },
      ]"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 6 }"
        show-word-limit
        maxlength="100"
        v-model="formData.reason"
        :placeholder="
          formData.reviewResult === 2
            ? '请输入原因（必填）'
            : '请输入原因（选填）'
        "
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <div class="disfr jc ac">
      <el-button size="small" type="primary" @click="handleSubmitAudit"
        >提交</el-button
      >
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      formData: {
        reviewResult: 1, // 固定为通过
        reason: "",
      },
      rules: {
        reviewResult: [{ required: true, message: "请选择审核结果" }],
      },
    };
  },
  methods: {
    handleSubmitAudit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData);
        }
      });
    },
    init() {
      this.formData = {
        reviewResult: 1,
        reason: "",
      };
    },
  },
  watch: {
    detailData() {
      this.init();
    },
  },
};
</script>

<style lang="scss">
.machineAuditModel {
  width: 50%;
  margin: 0 auto;
  .el-input,
  .el-textarea {
    display: inline-block;
    width: 300px;
  }
  .tip-text {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }
}
</style>
